import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { LoadingPanel } from "../../LoadingPanel";
import { addNotificationWithTimeout } from '../../../app/addNotificationWithTimeout';
import { handleResponse } from '../../../app/handleResponse';
import { getCSRFToken } from '../../../app/getCSRFToken';
import {
    Grid,
    GridColumn as Column,
} from "@progress/kendo-react-grid";

import './VenueEvent.scss';

export const AdministratorVenueEventTicketTypes = (props) => {
    const dispatch = useDispatch();

    const [venueEventTicketTypes, setVenueEventTicketTypes] = useState([]); 
    const [areVenueEventTicketTypesLoading, setAreVenueEventTicketTypesLoading] = useState(true);
    const [loadingError, setLoadingError] = useState("");

    const getVenueEventTicketTypes = () => {
        setAreVenueEventTicketTypesLoading(true);

        const dataItem = {
            venueEventKey: props.venueEventKey,
        };
    
        fetch(`/api/administrator/venueeventtickettypes`,
            {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                    "X-XSRF-TOKEN": getCSRFToken(),
                },
                body: JSON.stringify(dataItem),
            })
            .then(handleResponse)
            .then(result => {
                setVenueEventTicketTypes(result);
            })
            .catch(error => {
                addNotificationWithTimeout(dispatch, "error", error.message);
                                
                setLoadingError(error.message);
            })
            .finally(() => {
                setAreVenueEventTicketTypesLoading(false);
            });
    }

    useEffect(() => {
        if (props.venueEventKey) {
            getVenueEventTicketTypes();
        }
    }, []);

    return (
        <div>
            {areVenueEventTicketTypesLoading ? <LoadingPanel /> : (loadingError === "" ? (
                <>
                    <Grid
                        data={venueEventTicketTypes}
                        resizable={true}  
                        scrollable="none"
                    >
                        <Column field="dateCreated" title={"Created"} />
                        <Column field="dateUpdated" title={"Updated"} />
                        <Column field="name" title={"Name"} />
                        <Column field="venueEventTicketTypeStatusTypeName" title={"Status"} />
                        <Column field="price" title={"Price"} format="{0:c}" />
                        <Column field="taxesAndFees" title={"Fees"} format="{0:c}" />
                        <Column field="orderFee" title={"Order Fee"} format="{0:c}" />
                        <Column field="priceCurrencyCode" title={"Currency"} />
                        <Column field="purchaseTicketLimit" title={"Limit"} className="text-center" />
                        <Column field="minimumAge" title={"Min Age"} className="text-center" />
                        <Column field="capacity" title={"Capacity"} className="text-center" />
                        <Column field="isGeneralAdmission" title={"GA?"} />
                    </Grid>
                </>
            ) : <></>)
            }
        </div>
    );
}